import { createSlice } from '@reduxjs/toolkit'
import {LOCALES} from "../i18n";

const initialState = {
    rate: 0,
}

export const counterSlice = createSlice({
    name: 'rate',
    initialState,
    reducers: {
        changeRate: (state,{payload}) => {

            state.rate = payload
        },

    },
})

// Action creators are generated for each case reducer function
export const {changeRate} = counterSlice.actions

export default counterSlice.reducer